import { EUserRole, EUserType } from "src/app/shared/shared-data-models";

export interface StringGeneralResponse {
    success: boolean;
    message: string | undefined;
    status: EResponseStatus;
    resource: string | undefined;
}
export enum EResponseStatus {
    _0 = 0,
    _1 = 1,
    __1 = -1,
}


export class AdminLoginInputDto  {
    email!: string;
    password!: string;
    rememberMe?: boolean;
    userTypeId?: EUserType;
}
export class SetFundManagerPasswordInputDto  {
    email!: string;
    password!: string;
    confirmPassword!: string;
    otp?: boolean;
}
export interface AdminLoginReturnDtoGeneralResponse {
    success?: boolean;
    message?: string | undefined;
    status?: EResponseStatus;
    resource?: AdminLoginReturnDto;
}
export interface AdminLoginReturnDto {
    fullName: string | undefined;
    lastName: string | undefined;
    nationalId: string | undefined;
    userRoleId: EUserRole;
    isActivated: boolean;
    phoneNumber: string | undefined;
    birthDate: string | undefined;
    arabicName: string | undefined;
    englishName: string | undefined;
    refreshToken: string | undefined;
    gender: Gender;
    isSuspended: boolean;
    token: string | undefined;
    message: string | undefined;
    success: boolean;
    email: string | undefined;
    isCompleteProfile: boolean;
    expiryTokenInMinutes: number;
    userId: string | undefined;
}
export type Gender = "Male" | "Female" | "PreferredNotSay";

export interface AdminForgetPasswordInputDto {
    email: string;
}
export interface AdminNewPasswordInputDto {
    email: string;
    password: string;
    confirmPassword: string;
    otp: string;
    userTypeId: EUserType;
}
export interface AdminGenerateUserOTPInputDto {
    email: string;
    purpose?: OTPPurpose;
    userTypeId?: EUserType;
}
export interface AdminOTPInputDto {
    email: string;
    otp: string;
    userTypeId?: EUserType;
}

export enum OTPPurpose {
    Registration = "Registration",
    Login = "Login",
    ForgetPassword = "ForgetPassword",
    ChangeData = "ChangeData",
}

export interface AdminOTPOutputDto {
    createdAt?: Date | undefined;
    otpCreationDate?: Date | undefined;
    duration?: number | undefined;
    otp?: string | undefined;
    remainingSeconds?: number;
}

export interface AdminOTPOutputDtoGeneralResponse {
    success?: boolean;
    message?: string | undefined;
    status?: EResponseStatus;
    resource?: AdminOTPOutputDto;
}